define('../app/fukit/behavior/bind.component.model.to.container.model.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var BindComponentModelToContainerModelBehavior = Mn.Behavior.extend({
    initialize: function() {
      this.on('change:model', function() {
        this.view.children.each(function(child) {
          child.model = this.view.model;
        }, this);
      });

      this.on('add:child', function(child) {
        child.model = this.view.model;
      });
    },
  });

  module.exports = BindComponentModelToContainerModelBehavior;
});

